// Complemento de `standaloneFieldSx` (common/fieldStyles.js) para o
// `Autocomplete` do MUI. O `sx` do chamador é aplicado na RAIZ do
// `Autocomplete` (os seletores descendentes de `standaloneFieldSx` já alcançam
// o `TextField` interno), mas o `Autocomplete` reserva um `padding` próprio no
// `.MuiOutlinedInput-root` (9px; 6px no `size="small"`) e no `<input>`
// (`.MuiAutocomplete-input`). Sem este ajuste o valor digitado ficaria ~9px à
// direita do label (o label fica em `translate(14px, …)`) e o `padding` de
// 21px/7px do `<input>` seria sobrescrito pelo do próprio `Autocomplete` no
// `size="small"`.
//
// Só entra em cena quando o `sx` recebido traz a casca 52px (`standaloneFieldSx`
// ou cópia local equivalente, ex.: `ffFieldSx`). Sem `sx` (ou com `sx` de outro
// tipo — larguras, margens…) devolve o mesmo objeto, então o comportamento
// padrão dos consumidores existentes não muda.
//
// `padding-right` da raiz NÃO é mexido: é ele que reserva o espaço dos
// adornos de fim (ícone de abrir lista/limpar, `CircularProgress`), que ficam
// `position: absolute`.
const AUTOCOMPLETE_FIELD_SHELL_SX = {
    '& .MuiOutlinedInput-root.MuiInputBase-root.MuiAutocomplete-inputRoot': {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
    },
    // `.ff-input{padding:21px 14px 7px}` — direita curta (4px, igual ao
    // default do `Autocomplete`) porque a raiz já reserva o espaço dos adornos.
    '& .MuiOutlinedInput-root.MuiInputBase-root.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
        padding: '21px 4px 7px 14px',
    },
};

const hasFieldShell = (sx) =>
    Boolean(sx) &&
    typeof sx === 'object' &&
    !Array.isArray(sx) &&
    sx['& .MuiOutlinedInput-root']?.height === '52px';

export const withAutocompleteFieldShell = (sx) =>
    hasFieldShell(sx) ? { ...sx, ...AUTOCOMPLETE_FIELD_SHELL_SX } : sx;
